import React from 'react';
import RedirectSpinner from '../../../shared/RedirectSpinner'; // default export retained

const LoadingPopup: React.FC = () => (
  <RedirectSpinner
    message="Redirecting..."
    subMessage="Please do not close or refresh the window while we are saving your changes."
  />
);

export default LoadingPopup;
